/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { HELPDESK_MESSAGE, HELPDESK_COUNTRIES_PLACEHOLDER } from '../../const';
import HelpdeskService from './helpdesk.service';
import ObjectHelper from '../../helper/object.helper';
import Loading from '../loading/loading.component';

class HelpdeskComponent extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      countries: null,
      selectedCountry: '',
      selectedPhoneNumbers: null
    };
  }

  componentDidMount() {
    this.props.loadHelpdeskPhoneNumbers();
  }

  updateCountrySelection(e) {
    this.setState({
      selectedPhoneNumbers: this.state.countries.get(e.target.value).phoneNumbers,
      selectedCountry: e.target.value
    });
  }

  render() {
    const { allPhoneNumbers } = this.props;

    let body;
    if (this.props.isFetching) {
      body = <Loading />;
    } else {
      this.state.countries = ObjectHelper.toMap(this.props.allPhoneNumbers);
      body = (
        <div id="helpdesk-modal-view">
          <h3>{HELPDESK_MESSAGE}</h3>
          <form id="selectCountryForm" className="form-horizontal">
            <FormGroup controlId="country-select">
              <FormControl
                componentClass="select"
                required
                value={this.state.selectedCountry}
                onChange={this.updateCountrySelection.bind(this)}
              >
                <option disabled value="">
                  {HELPDESK_COUNTRIES_PLACEHOLDER}
                </option>
                {HelpdeskService.createCountrySelectItems(allPhoneNumbers)}
              </FormControl>
            </FormGroup>
            {HelpdeskService.createPhoneNumbersListItems(this.state.selectedPhoneNumbers)}
          </form>
        </div>
      );
    }

    return body;
  }
}

HelpdeskComponent.propTypes = {
  loadHelpdeskPhoneNumbers: PropTypes.func,
  allPhoneNumbers: PropTypes.object
};

export default HelpdeskComponent;
